import ProfileAvatar from "../avatar/ProfileAvatar";
import {
	CATALOG_DOCTOR_EMPTY_LABEL,
	instructorPersonLabel,
} from "../catalog/catalogInstructorDisplay";

export default function DetailInstructorBlock({
	instructors,
	label = "استاد",
	emptyMessage = CATALOG_DOCTOR_EMPTY_LABEL,
}) {
	const list = (instructors ?? [])
		.map((person) => ({
			...person,
			displayName: instructorPersonLabel(person),
		}))
		.filter((person) => person.displayName);

	return (
		<div className="rounded-[10px] bg-lightCta/70 px-3 py-2.5 text-right">
			<div className="font-Vazir-400 text-[12px] text-darkBlue/50">{label}</div>
			{list.length === 0 ? (
				<p className="mt-2 font-Vazir-400 text-[14px] leading-relaxed text-darkBlue/45">
					{emptyMessage}
				</p>
			) : (
				<ul className="mt-2 flex flex-col gap-2.5">
					{list.map((person) => (
						<li
							key={person.doctor_id ?? person.displayName}
							className="flex items-center justify-start gap-2"
						>
							<ProfileAvatar
								name={person.displayName}
								imageUrl={
									person.avatar_url ?? person.avatarUrl
								}
								size="md"
								className="ml-0.5"
							/>
							<span className="min-w-0 font-Vazir-300 text-[14px] text-darkBlue line-clamp-2">
								{person.displayName}
							</span>
						</li>
					))}
				</ul>
			)}
		</div>
	);
}
